import { Manifold } from '@manifoldco/manifold-shopify';

const preferredApps = ['trustwallet', 'metamask', 'coinbase'];

      // Define the connect options
      const connectOptions = {
        preferredNetwork: 'ethereum',
        preferredApps: preferredApps
      };

      // Create the m-connect button with the connect options
      console.log("test===1234509876",connectOptions);
      const connectButton = Manifold.createConnectButton(connectOptions);

      // Append the connect button to the page
      document.body.appendChild(connectButton);

            connectButton.addEventListener('click', async () => {
        // Get the selected wallet from the wallet picker
        const selectedWallet = await Manifold.createWalletPicker(preferredApps);

        // Connect the wallet
        const client = await Manifold.connect(selectedWallet, connectOptions);
        
        // Do something with the connected client
        console.log(client);
      });


      
      window.addEventListener('m-authenticated', async (event) => {
        // Get the data client instance
        const client = event.detail.client;

        // Get the NFTs owned by the currently connected wallet
        const tokens = await client.getNFTsOfOwner();
        const h2 = document.createElement("h2");
        h2.innerHTML = "Your NFTs";
        document.getElementById("nfts").appendChild(h2)
        // Create a div element for each token you own
        for (let i = 0; i < tokens.length; i++) {
          const img = document.createElement("img");
          img.src = tokens[i].image;
          img.height = 200;
          img.width = 200;
          document.getElementById("nfts").appendChild(img);
        }
      })
      window.addEventListener('m-unauthenticated', async (event) => {
        document.getElementById("nfts").innerHTML = "";
      })

// Create the modal base element
var $modalBase = $('<div class="walletconnect-modal__base"></div>');
console.log("Modal Base===",$modalBase);
// Fetch the list of supported apps using the WalletConnect client library
var wc = new WalletConnectProvider({
  bridge: "https://bridge.walletconnect.org"
});
var supportedApps = await wc.getWalletConnectorNames();

// Create a list element to display the supported apps
var $appList = $('<ul class="walletconnect-modal__app-list"></ul>');
$.each(supportedApps, function(index, appName) {
  var $appListItem = $('<li></li>');
  $appListItem.text(appName);
  $appList.append($appListItem);
});

// Append the app list to the modal base element
$modalBase.append($appList);

// Append the modal base element to the body of the page
$('body').append($modalBase);